/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceLeaderboardConfigMaxParticipantsRange } from './SurfaceLeaderboardConfigMaxParticipantsRange';
import {
    SurfaceLeaderboardConfigMaxParticipantsRangeFromJSON,
    SurfaceLeaderboardConfigMaxParticipantsRangeFromJSONTyped,
    SurfaceLeaderboardConfigMaxParticipantsRangeToJSON,
    SurfaceLeaderboardConfigMaxParticipantsRangeToJSONTyped,
} from './SurfaceLeaderboardConfigMaxParticipantsRange';

/**
 * Leaderboard-specific configuration for hub activities
 * @export
 * @interface SurfaceLeaderboardConfig
 */
export interface SurfaceLeaderboardConfig {
    /**
     * Allowed period types (DAILY, WEEKLY, MONTHLY, CUSTOM)
     * @type {Array<string>}
     * @memberof SurfaceLeaderboardConfig
     */
    allowedPeriodTypes?: Array<string>;
    /**
     * Default period type pre-selected in wizard
     * @type {string}
     * @memberof SurfaceLeaderboardConfig
     */
    defaultPeriodType?: string;
    /**
     * Allowed aggregation modes (SUM, MAX, AVERAGE, COUNT)
     * @type {Array<string>}
     * @memberof SurfaceLeaderboardConfig
     */
    allowedAggregationModes?: Array<string>;
    /**
     * Default aggregation mode pre-selected in wizard
     * @type {string}
     * @memberof SurfaceLeaderboardConfig
     */
    defaultAggregationMode?: string;
    /**
     * ScoringTemplate ID auto-selected for leaderboards
     * @type {string}
     * @memberof SurfaceLeaderboardConfig
     */
    defaultScoringTemplateId?: string;
    /**
     * 
     * @type {SurfaceLeaderboardConfigMaxParticipantsRange}
     * @memberof SurfaceLeaderboardConfig
     */
    maxParticipantsRange?: SurfaceLeaderboardConfigMaxParticipantsRange;
}

/**
 * Check if a given object implements the SurfaceLeaderboardConfig interface.
 */
export function instanceOfSurfaceLeaderboardConfig(value: object): value is SurfaceLeaderboardConfig {
    return true;
}

export function SurfaceLeaderboardConfigFromJSON(json: any): SurfaceLeaderboardConfig {
    return SurfaceLeaderboardConfigFromJSONTyped(json, false);
}

export function SurfaceLeaderboardConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceLeaderboardConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'allowedPeriodTypes': json['allowedPeriodTypes'] == null ? undefined : json['allowedPeriodTypes'],
        'defaultPeriodType': json['defaultPeriodType'] == null ? undefined : json['defaultPeriodType'],
        'allowedAggregationModes': json['allowedAggregationModes'] == null ? undefined : json['allowedAggregationModes'],
        'defaultAggregationMode': json['defaultAggregationMode'] == null ? undefined : json['defaultAggregationMode'],
        'defaultScoringTemplateId': json['defaultScoringTemplateId'] == null ? undefined : json['defaultScoringTemplateId'],
        'maxParticipantsRange': json['maxParticipantsRange'] == null ? undefined : SurfaceLeaderboardConfigMaxParticipantsRangeFromJSON(json['maxParticipantsRange']),
    };
}

export function SurfaceLeaderboardConfigToJSON(json: any): SurfaceLeaderboardConfig {
    return SurfaceLeaderboardConfigToJSONTyped(json, false);
}

export function SurfaceLeaderboardConfigToJSONTyped(value?: SurfaceLeaderboardConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowedPeriodTypes': value['allowedPeriodTypes'],
        'defaultPeriodType': value['defaultPeriodType'],
        'allowedAggregationModes': value['allowedAggregationModes'],
        'defaultAggregationMode': value['defaultAggregationMode'],
        'defaultScoringTemplateId': value['defaultScoringTemplateId'],
        'maxParticipantsRange': SurfaceLeaderboardConfigMaxParticipantsRangeToJSON(value['maxParticipantsRange']),
    };
}

